import { NumberMaskProps, MaskProps } from '../types'

const setCharAt = (text: string, index: number, newText: string) => {
  if (index > text.length - 1) {
    return text
  }

  return text.substring(0, index) + newText + text.substring(index + 1)
}

export const patternMask = (value = '', pattern = '') => {
  let formattedText = value?.replace(/\D/g, '')

  pattern
    ?.slice()
    ?.split('')
    ?.forEach((character, index) => {
      if (/x/.test(character)) {
        formattedText = setCharAt(formattedText, index, formattedText[index])
      } else if (formattedText[index]) {
        formattedText = setCharAt(formattedText, index, character + formattedText[index])
      }
    })

  return formattedText?.slice(0, pattern.length)
}

export const numberMask = (value = '', maskOptions: NumberMaskProps) => {
  const defaultMaskOptions: NumberMaskProps = {
    locale: 'pt-BR',
    style: 'decimal',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }

  let newValue: string | number = String(value)?.replace(/(\D)/g, '')

  const { locale, type, ...intlOptions } = { ...defaultMaskOptions, ...maskOptions }

  const fractionDigits = Number(intlOptions.maximumFractionDigits)
  const numberToDivide = Number('1'.padEnd(fractionDigits + 1, '0'))

  if (maskOptions.style === 'percent') {
    newValue = Number(newValue) / 100
  }

  newValue = Number(newValue) / numberToDivide

  if (value === '') {
    return ''
  }

  return new Intl.NumberFormat(locale, intlOptions).format(newValue)
}

export const getMaskedValue = (value: string, mask: MaskProps) => {
  if (typeof mask === 'string') {
    return patternMask(value, mask)
  }

  if (typeof mask === 'function') {
    return mask(value)
  }

  if (typeof mask === 'object') {
    return numberMask(value, mask)
  }

  return value
}
